import { OccurenceListCommentsComponent } from './occurence-list-comments/occurence-list-comments.component';
import { OccurenceDatesComponent } from './occurence-dates/occurence-dates.component';
import { Component, OnInit, Input, Output, EventEmitter, Inject, HostListener } from '@angular/core';

import { Validators, FormGroup, FormBuilder, FormControl, FormArray, ValidatorFn, AbstractControl } from '@angular/forms';

import { OccurencesService } from '../occurences.service';
import { Occurence } from '../model/occurence.model';
import { MatDialogRef, MatBottomSheet} from '@angular/material';
import { MAT_DIALOG_DATA} from '@angular/material/dialog';
import { OccurenceType } from '../model/occurence-type.model';
import { Observable, throwError, of} from 'rxjs';
import { AuthService } from '../../core/auth/auth.service';
import { AuthUser } from '../../core/auth/auth-frame/auth-user.model';
import { DateOccurrenceType } from '../model/date-occurrence-type.model';
import { OccurenceStatus } from '../model/occurence-status.model';
import { AlertService } from '../../shared/alert/alert.service';
import { SnackbarService } from '../../../app/shared/services/snackbar.service';
import { ConfirmDialogComponent } from '../../shared/confirm-dialog/confirm-dialog.component';
import { OccurenceComments } from './occurence-list-comments/occurence-comments.interface';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { UtilService } from '../../shared/utils';
import { CONSTANTS } from '@app/shared/constants';
import { ViewChild } from '@angular/core';
import { OccurenceTypesComponent } from '@app/occurences/add-occurence-modal/occurence-types/occurence-types.component';
import { ViewEncapsulation } from '@angular/core';
import { OccurenceDataComponent } from '@app/occurences/add-occurence-modal/occurence-data/occurence-data.component';
@Component({
  selector: 'app-add-occurence-modal',
  templateUrl: './add-occurence-modal.component.html',
  styleUrls: ['./add-occurence-modal.component.css']
})

export class AddOccurenceModalComponent implements OnInit {

  comments: Array<OccurenceComments> = new Array<OccurenceComments>();
  occurrenceId: any;
  @Input() value: Number = 0;
  @Input() showLoading: Boolean = false;
  @ViewChild(OccurenceTypesComponent) occurrenceTypesChild:OccurenceTypesComponent;
  @ViewChild(OccurenceDatesComponent) occurrenceDatesChild:OccurenceDatesComponent;
  @ViewChild(OccurenceDataComponent) occurrenceDataChild:OccurenceDataComponent;
  @ViewChild(OccurenceListCommentsComponent) occurrenceListChild:OccurenceListCommentsComponent;
  private authUser: AuthUser;
  authSubject: Observable<AuthUser>;

  isCreate        : boolean = false;
  isRead          : boolean = false;
  haveDownloads   : boolean = true;

  typesSelectedList: any = new Array<any>();
  occurenceTypes: any = new Array<any>();
  occurrenceForm: FormGroup;
  commentsOccurrenceForm: FormGroup;
  SINGLE_DATE: string = 'única data';
  MULTIPLE_DATES: string = 'múltiplas datas';
  INIT_STATUS_NAME: string = 'Aberto';
  typeModel: string;
  occurrenceView: boolean = false;
  filesSelected: any = [];
  hasSubmitted: boolean = false;

  showListComments: boolean = false;

  instanceTypesChecked: Array<DateOccurrenceType>;

  ocurrenceWasSaved: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) private matDialogData: any,
    private formBuilder: FormBuilder,
    private occurenceService: OccurencesService,
    private dialogRef: MatDialogRef<AddOccurenceModalComponent>,
    private authService: AuthService,
    private alertService: AlertService,
    private _snackbarService: SnackbarService,
    private bottomSheet: MatBottomSheet,
    private utils: UtilService,
  ) {
    this.authSubject = this.authService.getAuthModel();
    this.authSubject.subscribe((user: AuthUser) => {
      this.authUser = user;
    });
  }

  ngOnInit() {
    this.setDefaultOption();
    this.dialogRef.disableClose = true;
    this.commentsOccurrenceForm = this.formBuilder.group(
      {
        comments: ['',[Validators.required,Validators.maxLength(1500)]]
      }
    );

    this.occurrenceForm = this.formBuilder.group(
      {
        id: [''],
        description: ['',Validators.maxLength(2000)],
        dataForm: this.formBuilder.group(
          {
            fName: [{value: '', disabled: this.isRead }, Validators.required],
            fCpfCnpj: [{value: '', disabled: this.isRead }, [Validators.required, this.cpfCnpjValidator]],
            fCode: [{value: '', disabled: this.isRead }],
            fundNumber: [''],
            statusDemanda:[''],
            // mySelectNameField : '',
          },
          {
            updateOn: 'submit'
          }
        ),
        datesForm: this.formBuilder.group(
          {
            fRbDate: [{ value: this.SINGLE_DATE, disabled: this.isRead }, [Validators.required]],
            dateArray: this.formBuilder.array([]),
            dateArrayFinal: this.formBuilder.array([])
          }
        ),
        typesForm: this.formBuilder.group(
          {
            typesListControl: ['', this.validateMinSelected]
          },
          {
            updateOn: 'submit'
          }
        ),
        filesForm: this.formBuilder.group(
          {
            files: ['']
          }
        )
      }
    );
    
    if (this.isRead) {
      this.manageOccurrence(this.matDialogData);
    }

    this.setConfirmOnCloseModal();
  }

  setDefaultOption(): void {
    if (this.matDialogData && Object.keys(this.matDialogData).length > 0) {
      this.isRead = true;
      this.isCreate = false;
    } else {
      this.isCreate = true;
      this.isRead = false;
    }
  }

  setConfirmOnCloseModal(): void {
    this.dialogRef.backdropClick().subscribe(response => {
      this.askSureBeforeClose();
    });
  }

  manageNewComment(newComments: boolean) {
    if(newComments) {
      this.showListComments = true;
      this.occurrenceListChild.loadComments();
      if (this.matDialogData.hasComments > 0) {
        this.matDialogData.hasComments++;
      } else {
        this.matDialogData.hasComments = 1;
      }

    }
  }

  manageOccurrence(occurrenceData: any): void {
    this.occurrenceForm.controls['id'].setValue(occurrenceData.id);
    const dataPatchValue = {
      dataForm: {
        fName: occurrenceData.fundName,
        fCpfCnpj: occurrenceData.fundCnpjCpf,
        fCode: occurrenceData.fundCode,
        statusDemanda: occurrenceData.occurrenceStatus.name
      }
    };
    this.occurrenceForm.patchValue(dataPatchValue);
    this.occurrenceForm.controls['description'].setValue(occurrenceData.description);
    this.occurrenceForm.controls['description'].disable();
    if (occurrenceData.hasComments > 0) {
      this.showListComments = true;
    }
    // - Check if have more than one date.
    if (Array.isArray(occurrenceData.dateOccurrenceTypes) && occurrenceData.dateOccurrenceTypes.length > 0) {
      let isNotUniqueDate = occurrenceData.dateOccurrenceTypes.map(item => item.suggestedDate).filter((value, index, self) => self.indexOf(value) === index).length > 1;
      if (isNotUniqueDate) {
        // - Multiple date.
        this.occurrenceForm.patchValue({datesForm: {fRbDate: this.MULTIPLE_DATES}});
      } else {
        // - Single date.
        this.occurrenceForm.patchValue({datesForm: {fRbDate: this.SINGLE_DATE}});
      }
    }
    if (!occurrenceData.storedDocument || (occurrenceData.storedDocument && occurrenceData.storedDocument.length === 0)) {
      this.haveDownloads = false;
    }
    if (Array.isArray(occurrenceData.storedDocument) && occurrenceData.storedDocument.length > 0) {
      this.filesSelected = occurrenceData.storedDocument;
    }
    this.instanceTypesChecked = occurrenceData.dateOccurrenceTypes;
    this.comments = occurrenceData.occurrenceComments;
    this.occurrenceId = occurrenceData.id;

  }

  get dateArray() {
    return this.occurrenceForm.get('datesForm').get('dateArray') as FormArray;
  }

  get dateArrayFinal() {
    return this.occurrenceForm.get('datesForm').get('dateArrayFinal') as FormArray;
  }

  listTypes(e: any) {
    this.typesSelectedList = new Array<any>();
    this.typesSelectedList.push(e);
  }

  occurenceTypesChange(e: any) {
    this.occurenceTypes = new Array<any>();
    this.occurenceTypes.push(e);
  }

  onSubmit() {
    if (this.occurrenceForm.invalid) {
      this.occurrenceForm.get('dataForm').markAsTouched({ onlySelf: false });
      return;
    }

    this.typeModel = '';
    this.createOccurence(this.buildOccurrence(), this.occurrenceForm.get('filesForm').get('files').value);
    
  }

  enableDataFields(event: boolean): void {
    if (event) {
      this.occurrenceForm.get('dataForm').enable();
    } else {
      this.occurrenceForm.get('dataForm').disable();
    }
  }

  disableFieldsAfterCreate(entity: any): void {
    this.occurrenceTypesChild.disableAllCheckboxes();
    this.occurrenceForm.get('description').disable();
    this.occurrenceForm.get('dataForm').disable();
    this.occurrenceForm.get('datesForm').disable();
    this.occurrenceForm.get('typesForm').disable();
    this.occurrenceDataChild.disableFields();
  }

  createOccurence(occurrence: Occurence, filesToUpload: Array<File>) {
    this.showLoading = true;
    let msg = '';
    this.occurenceService.createOccurence(occurrence, filesToUpload).subscribe(
      event => {
        msg = 'Sua solicitação foi realizada com sucesso!';
        this.showLoading = false;
        this._snackbarService.showSnackbar(msg, 'OK');
        this.disableFieldsAfterCreate(occurrence);
        this.ocurrenceWasSaved = true;
      },
      err => {
        msg = `Solicitação não processada!
        Por favor, tente novamente. Caso o problema persista, contate o seu canal de atendimento.`;

        this.showLoading = false;
        this._snackbarService.showSnackbar(msg, 'OK');
        this.ocurrenceWasSaved = false;
      },
      () => {
        this.hasSubmitted = true;
      }
    );
  }

  private buildOccurrence(): Occurence {
    //Status
    const occurrenceStatus = new OccurenceStatus(null, this.INIT_STATUS_NAME, null, null);

    //Fund
    let fundName: string = this.occurrenceForm.get('dataForm').get('fName').value;
    let tradeName: string = this.occurrenceForm.get('dataForm').get('fName').value;
    let fundCnpjCpf: string = this.occurrenceForm.get('dataForm').get('fCpfCnpj').value;
    let fundCode: string = this.occurrenceForm.get('dataForm').get('fCode').value;
    let fundNumber: number =  this.occurrenceForm.get('dataForm').get('fundNumber').value;
    let description: string = this.occurrenceForm.get('description').value;
    //Occurrence
    let id: number = null;
    let creationDateTime: Date = null;
    let userName: string = this.authUser.gestor;
    let typesListControl: Array<OccurenceType> = this.occurrenceForm.get('typesForm').get('typesListControl').value;
    let dateOccurrenceTypes: Array<DateOccurrenceType> = new Array<DateOccurrenceType>();

    for (const { item, index } of typesListControl.map((item, index) => ({ item, index }))) {
      let suggestedDate: Date = null;
      let approvedDate: Date = null;
      if (this.occurrenceForm.get('datesForm').get('fRbDate').value === this.SINGLE_DATE) {
        suggestedDate = this.dateArray.at(0).value;
        approvedDate = this.dateArrayFinal.at(0).value;
      } else {
        suggestedDate = this.dateArray.at(index).value;
        approvedDate = this.dateArrayFinal.at(index).value;
      }
      //DateOccurrenceType
      let dateOccurrenceTypeId = null
      let updateDateTime: Date = null;
      let dateOccurrenceType: DateOccurrenceType = new DateOccurrenceType(dateOccurrenceTypeId, item, id, updateDateTime, suggestedDate, approvedDate);
      dateOccurrenceTypes.push(dateOccurrenceType);
    }//end for

    let occurence: Occurence = new Occurence(id, creationDateTime, tradeName, userName, fundName, fundCnpjCpf, fundCode, description, occurrenceStatus, dateOccurrenceTypes,[], fundNumber);

    return occurence;
  }

  multipleDate(isMultiple: boolean) {
    return isMultiple;
  }

  validateMinSelected(control: FormControl): { [key: string]: any } {
    if (control.value) {
      if (control.value.length < 1) {
        return { "validateMinSelected": true };
      }
    } else {
      return { "validateMinSelected": true };
    }
    return null;
  }

  cpfCnpjValidator(control: FormControl): { [key: string]: any } {
    if (control.value) {
      if (control.value != "" && !OccurencesService.cpfCnpjValidator(control.value)) {
        return { 'cpfCnpjValidator': true };
      }
    }
    return null;
  }

  @HostListener('window:keyup.esc') onKeyUp() {
    this.askSureBeforeClose();
  }

  askSureBeforeClose(): void {
    if (this.commentsOccurrenceForm.get('comments').value != '') {
      this.bottomSheet.open(ConfirmDialogComponent, {
        data: { message: 'As alterações não serão enviadas. Deseja continuar?' }
      }).afterDismissed().subscribe(data => {
        if(data && data.message === 'Confirm') {
          this.dialogRef.close();
        }
      });
    } else {
      this.dialogRef.close();
    }
  }

  closeModal() {
    this.askSureBeforeClose();
  }

  // verifica se o retorno da requisição foi success
  isSuccess(): boolean {
    return this.typeModel == 'success';
  }

  // verifica se o retorno da requisição foi error
  isError(): boolean {
    return this.typeModel == 'error';
  }

  validateWallet() {
    const data = this.occurrenceForm.get('dataForm').get('fName').value;
    const containsInputWallet = document.getElementById('mySelectNameField') !== null;

    if (!data && containsInputWallet) {
      this._snackbarService.showSnackbar(CONSTANTS.INFO_REQUIRED_PORTFOLIO, CONSTANTS.GLOBAL.OK);
      return false;
    }
  }

}
